import { AppConfig } from './models/app-config';

export const config: AppConfig = {
  name: 'AMPER ON',
  defaultLanguage: 'en',
  // TODO: restore 'ar' (and showTopBar) when Arabic is re-enabled
  availableLanguages: ['en'],
  noVAT: false,
  separateInvoiceCreation: false,
  allowPrivateIndividualRegistration: false,
  publicPagesVersion: 'v2',
  showTopBar: false,
  item: {
    code: {
      width: 150,
    },
    manufacturer: {
      width: 150,
    },
    itemGroup: {
      visible: false,
      width: 150,
    },
    quantity: {
      visible: true,
      width: 80,
    },
    plannedQuantity: {
      visible: false,
      width: 110,
    },
    vendorQuantity: {
      visible: false,
      width: 80,
    },
    minimumOrderQuantity: {
      width: 110,
    },
    deliveryDate: {
      visible: false,
      width: 110,
    },
    packageAmount: {
      visible: false,
      width: 0,
    },
    unit: {
      width: 80,
    },
    netWeight: {
      visible: false,
      width: 0,
    },
    datasheet: {
      width: 60,
    },
    priceList: {
      visible: false,
      width: 180,
    },
    delivery: {
      visible: false,
    },
    priceWithoutVAT: {
      width: 80,
    },
    discount: {
      visible: false,
      width: 0,
    },
    price: {
      visible: false,
      width: 80,
    },
  },
  basket: {
    deliveryAddress: {
      visible: true,
    },
    urgentOrder: {
      visible: false,
    },
    item: {
      totalPrice: {
        width: 90,
      },
    },
  },
  invoice: {
    packingList: {
      visible: true,
    },
  },
  quotation: {
    delivery: {
      visible: true,
    },
  },
  downloads: {
    stock: {
      visible: ['combinedStock'],
    },
  },
};
